import Icon from 'components/elements/Icon'

import { useActionless } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import styles from './emptyDeckLanding.module.scss'

const Search = () => {
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  return (
    <button className={styles.landingButton} onClick={() => setActiveState({ searchOpen: 'search' })}>
      <Icon name="search" link style={{ color: '#A1C181' }} size="massive" />
      <h4>Add Cards From Search</h4>
    </button>
  )
}

export default Search
